import { __PROD__, __STAGING__ } from "./utils/dev";

export const config = {
  GA_MEASUREMENT_ID: "G-K5HWHPL62Y",
  DMA_ARK_CONFIG: __PROD__
    ? "https://ark.entermetaverse.fun/static/config/16ba9b9d-ed81-4100-8564-988eff81bac2.json"
    : "https://ark.entermetaverse.fun/static/config/8b47b963-aeaf-4c2c-8672-3d5cd320a5c5.json",
  LOYALTY_ARK_FAQ:
    "https://ark.entermetaverse.fun/static/config/7bfafc0c-241d-47af-81e5-faee8f460f0c.json",
  DELYSIUM_CLIENT_URL: __PROD__ ? "https://www.delysium.com/" : "https://www-staging.delysium.com/",
  DELYSIUM_ONE_CLIENT_URL: __PROD__
    ? "https://www.delysium.one/"
    : "https://www-staging.delysium.one/",
  MARKETPLACE_CLIENT_URL: __PROD__
    ? "https://marketplace.delysium.com/"
    : __STAGING__
    ? "https://marketplace-staging.delysium.com/"
    : "https://marketplace-dev.delysium.com/",
  SSO_CLIENT_URL: __PROD__
    ? "https://auth.delysium.one"
    : __STAGING__
    ? "https://auth-staging.delysium.one"
    : "https://auth-dev.delysium.one",
  DASHBOARD_UI: __PROD__
    ? "https://dashboard.delysium.one/"
    : __STAGING__
    ? "https://dashboard-staging.delysium.one/"
    : "https://dashboard-dev.delysium.one/",
  SSO_API_URL: __PROD__
    ? "https://sso.delysium.one"
    : __STAGING__
    ? "https://sso-stg.delysium.one"
    : "https://sso-dev.delysium.one",
  MARKET_API_URL: __PROD__
    ? "https://market-api.delysium.com/api/v1"
    : __STAGING__
    ? "https://market-api-staging.delysium.com/api/v1"
    : "https://market-api-dev.delysium.com/api/v1",
  SYNCER_API_URL: __PROD__
    ? "https://syncer-bsc-api.delysium.com/api/v1"
    : "https://syncer-api-staging.delysium.com/api/v1",
  DMA_API_URL: __PROD__
    ? "https://dma-api.delysium.one/api/v1"
    : __STAGING__
    ? "https://dma-api-staging.delysium.one/api/v1"
    : "https://dma-api-dev.delysium.one/api/v1",
  BASE_API_URL: __PROD__
    ? "https://api.delysium.one/api/v1"
    : __STAGING__
    ? "https://api-staging.delysium.one/api/v1"
    : "https://api-dev.delysium.one/api/v1",

  // solana RPC
  SOLANA_RPC: __PROD__
    ? "https://withered-winter-theorem.solana-mainnet.quiknode.pro/10a8627e80f0c6498f03609da91df3178dfadbfb/"
    : __STAGING__
    ? "https://greatest-fluent-breeze.solana-devnet.quiknode.pro/1c0a18462d111bef7479cd1944b67b2060807c9f/"
    : "https://greatest-fluent-breeze.solana-devnet.quiknode.pro/1c0a18462d111bef7479cd1944b67b2060807c9f/",

  // solana AGI Contract
  SOL_AGI_CONTRACT: __PROD__
    ? "8bUbe1ujsM1G3JEbBWVVCXa2widmuPdKUB2rGKMYFw7R"
    : __STAGING__
    ? "967rqnXY2yZoEc6CSE94gdvEsqXX46PGGkDbY2UxdZz5"
    : "967rqnXY2yZoEc6CSE94gdvEsqXX46PGGkDbY2UxdZz5",

  SOLANA_NETWORK_PHANTOM: __PROD__ ? "mainnet-beta" : __STAGING__ ? "devnet" : "devnet"
};
